import { render, staticRenderFns } from "./_config.vue?vue&type=template&id=d8521c5e"
import script from "./_config.vue?vue&type=script&lang=js"
export * from "./_config.vue?vue&type=script&lang=js"
import style0 from "./_config.vue?vue&type=style&index=0&id=d8521c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports